// extracted by mini-css-extract-plugin
module.exports = {"errorTitle":"goodsErrorRow_errorTitle__d0P1X","errorDesc":"goodsErrorRow_errorDesc__1A3N_"};